export default class Capabilities {
	constructor () {
		this.addHandlers()

		this.selectedOs = document.querySelector('ul.drop-os a.default')
		this.selectedElement = document.querySelector('#capabilities_group > a')
		this.browsersLoaded = false

		this.showCode()
	}

	addHandlers () {
		document.addEventListener('click', function (e) {
			const dropdownMenus = document.querySelectorAll('ul.dropdown-menu')
			dropdownMenus.forEach((dropdownMenu) => {
				dropdownMenu.style.display = 'none'
			})
		})

		const dropdownBrowserButton = document.querySelector('button.dropdown-browser')
		dropdownBrowserButton.addEventListener('click', e => this.openDropdownBrowser(e))
		dropdownBrowserButton.addEventListener('touchstart', e => this.openDropdownBrowser(e), { passive: true })

		const capabilitiesGroup = document.querySelector('#capabilities_group')
		capabilitiesGroup.addEventListener('click', e => this.onClickBrowser(e))
		capabilitiesGroup.addEventListener('touchstart', e => this.onClickBrowser(e), { passive: true })
	}

	openDropdownOS (e) {
		e.stopPropagation()
		e.preventDefault()
		const clickedElement = e.currentTarget

		const containerName = clickedElement.getAttribute('data-container')
		const dropdownMenus = document.querySelectorAll('ul.dropdown-menu')

		dropdownMenus.forEach(function (dropdownMenu) {
			if (!dropdownMenu.classList.contains(containerName)) {
				dropdownMenu.style.display = 'none'
			}
		})

		const element = document.querySelector('ul.' + containerName)
		if (element) {
			if (element.style.display === 'none') {
				element.style.display = 'block'
			} else {
				element.style.display = 'none'
			}
		}
	}

	async openDropdownBrowser (e) {
		e.stopPropagation()
		if (!this.browsersLoaded) {
			await this.loadBrowsers()
		}
		const containerName = 'puppeteer'
		const dropdownMenus = document.querySelectorAll('ul.dropdown-menu')
		dropdownMenus.forEach(function (dropdownMenu) {
			if (dropdownMenu.id !== containerName) {
				dropdownMenu.style.display = 'none'
			}
		})
		const element = document.querySelector('#' + containerName)
		if (element) {
			if (element.style.display === 'none') {
				element.style.display = 'block'
			} else {
				element.style.display = 'none'
			}
		}
	}

	async loadBrowsers () {
		this.browsersLoaded = true
		return new Promise((resolve, reject) => {
			fetch('/support/capabilities_puppeteer')
				.then(response => response.text())
				.then(data => {
					const capabilitiesGroup = document.querySelector('#capabilities_group')
					capabilitiesGroup.innerHTML = data
					capabilitiesGroup.style.display = 'block'
					resolve()
				})
				.catch(error => reject(error))
		})
	}

	onClickBrowser (e) {
		e.stopPropagation()
		let clickedElement = e.target
		let i = 0
		while (clickedElement && clickedElement.tagName !== 'A' && i < 4) {
			clickedElement = clickedElement.parentNode
			i += 1
		}
		this.selectedElement.classList.remove('selected')

		const dropdownMenus = document.querySelectorAll('ul.dropdown-menu')
		dropdownMenus.forEach(function (dropdownMenu) {
			dropdownMenu.style.display = 'none'
		})
		document.querySelector('.browserName').innerHTML = clickedElement.innerHTML
		this.selectedElement = clickedElement
		clickedElement.classList.add('selected')
		this.showCode()
	}

	handleQuotes (element, elementStr) {
		if (element.length > 0 && element.html().indexOf("'") > -1) {
			elementStr = "'" + elementStr + "'"
		} else if (element.length > 0 && element.html().indexOf('"') > -1) {
			elementStr = '"' + elementStr + '"'
		}

		return elementStr
	}

	contains (elements, text) {
		return [].filter.call(elements, function (element) {
			return RegExp(text).test(element.textContent)
		})
	}

	showCode () {
		const element = this.selectedElement
		const platform = element.getAttribute('data-platform')
		let browserName = element.getAttribute('data-name')
		if (browserName === 'iexplore') {
			browserName = 'internet explorer'
		} else if (browserName === 'googlechrome') {
			browserName = 'chrome'
		}
		let version = element.getAttribute('data-version')
		let deviceName = element.getAttribute('data-deviceName')
		let platformName = element.getAttribute('data-platformName')

		if (version === '0') {
			version = ''
		}

		let template

		if (document.querySelector('#capTemplateMobile') || document.querySelector('#capTemplate')) {
			if (element.getAttribute('data-deviceName')) {
				template = document.querySelector('#capTemplateMobile')
			} else {
				template = document.querySelector('#capTemplate')
			}

			const code = template.cloneNode(true)
			const platformElement = Array.from(this.contains(code.querySelectorAll('*'), '%platform%')).pop()
			if (platformElement && ((platformElement.innerHTML.indexOf('http') > -1) || platformElement.innerHTML.indexOf('wss') > -1)) {
				platformElement.innerHTML = platformElement.innerHTML.replace('%platform%', platform)
				platformElement.innerHTML = platformElement.innerHTML.replace('%browser%', browserName)
				platformElement.innerHTML = platformElement.innerHTML.replace('%version%', version)
			} else {
				const browserElement = Array.from(this.contains(code.querySelectorAll('*'), '%browser%')).pop()

				browserName = this.handleQuotes(browserElement, browserName)

				if (platformElement && platformElement.length > 0 && platformElement.tagName.toUpperCase() === 'CODE') {
					platformElement.innerHTML = platformElement.innerHTML.replace('%platform%', platform)
					browserElement.innerHTML = browserElement.innerHTML.replace('%browser%', browserName)
					Array.from(this.contains(code.querySelectorAll('*'), '%version%')).pop().innerHTML = Array.from(this.contains(code.querySelectorAll('*'), '%version%')).pop().innerHTML.replace('%version%', version)
					if (element.getAttribute('data-deviceName')) {
						const deviceNameElement = Array.from(this.contains(code.querySelectorAll('*'), '%deviceName%')).pop()
						deviceName = this.handleQuotes(deviceNameElement, deviceName)
						deviceNameElement.innerHTML = deviceNameElement.innerHTML.replace('%deviceName%', deviceName)
						const platformNameElement = Array.from(this.contains(code.querySelectorAll('*'), '%platformName%')).pop()
						platformName = this.handleQuotes(platformNameElement, platformName)
						platformNameElement.innerHTML = platformNameElement.innerHTML.replace('%platformName%', platformName)
					}
				} else {
					Array.from(this.contains(code.querySelectorAll('*'), '%browser%')).pop().innerHTML = browserName
					Array.from(this.contains(code.querySelectorAll('*'), '%version%')).pop().innerHTML = version
					Array.from(this.contains(code.querySelectorAll('*'), '%platform%')).pop().innerHTML = platform

					if (element.getAttribute('data-deviceName')) {
						const deviceNameElementFound = Array.from(this.contains(code.querySelectorAll('*'), '%deviceName%')).pop()
						deviceName = this.handleQuotes(deviceNameElementFound, deviceName)
						deviceNameElementFound.innerHTML = deviceName

						const platformNameElementFound = Array.from(this.contains(code.querySelectorAll('*'), '%platformName%')).pop()
						platformName = this.handleQuotes(platformNameElementFound, platformName)
						platformNameElementFound.innerHTML = platformName
					}
				}
			}
			document.querySelector('#capCode').innerHTML = code.innerHTML
		}
	}
}
